import { InjectionToken, Directive, ElementRef, Optional, Inject, Renderer2, Input, HostListener, NgModule } from '@angular/core';
import { NgModel, NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
const AUTO_SIZE_INPUT_OPTIONS = new InjectionToken('autosize-input-options');
const DEFAULT_AUTO_SIZE_INPUT_OPTIONS = {
    extraWidth: 0,
    includeBorders: false,
    includePadding: true,
    includePlaceholder: true,
    maxWidth: -1,
    minWidth: -1,
    setParentWidth: false,
    usePlaceHolderWhenEmpty: false,
};

class AutoSizeInputDirective {
    constructor(element, ngModel, ngControl, options, renderer) {
        this.element = element;
        this.ngModel = ngModel;
        this.ngControl = ngControl;
        this.options = options;
        this.renderer = renderer;
        this.extraWidth = this.defaultOptions.extraWidth;
        this.includeBorders = this.defaultOptions.includeBorders;
        this.includePadding = this.defaultOptions.includePadding;
        this.includePlaceholder = this.defaultOptions.includePlaceholder;
        this.maxWidth = this.defaultOptions.maxWidth;
        this.minWidth = this.defaultOptions.minWidth;
        this.setParentWidth = this.defaultOptions.setParentWidth;
        this.usePlaceHolderWhenEmpty = this.defaultOptions.usePlaceHolderWhenEmpty;
        this.useValueProperty = false;
        this.destroy$ = new Subject();
    }
    get borderWidth() {
        return this.includeBorders ? this._sumPropertyValues(['border-right-width', 'border-left-width']) : 0;
    }
    get defaultOptions() {
        return this.options || DEFAULT_AUTO_SIZE_INPUT_OPTIONS;
    }
    get paddingWidth() {
        return this.includePadding ? this._sumPropertyValues(['padding-left', 'padding-right']) : 0;
    }
    get style() {
        return getComputedStyle(this.element.nativeElement, '');
    }
    ngAfterViewInit() {
        if (this.ngModel) {
            this.ngModel.valueChanges.pipe(tap(() => this.updateWidth()), takeUntil(this.destroy$)).subscribe();
        }
        else if (this.ngControl) {
            this.ngControl.valueChanges.pipe(tap(() => this.updateWidth()), takeUntil(this.destroy$)).subscribe();
            this.updateWidth();
        }
        else {
            this.updateWidth();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    onInput(event) {
        if (!this.ngModel && !this.ngControl) {
            this.updateWidth();
        }
    }
    getInputValue() {
        let value;
        if (this.useValueProperty) {
            value = this._getProperty('value');
        }
        else if (this.ngModel) {
            value = this.ngModel.value;
        }
        else if (this.ngControl) {
            value = this.ngControl.value;
        }
        return value || this._getProperty('value') || '';
    }
    setWidth(width) {
        const { nativeElement } = this.element;
        const parent = this.renderer.parentNode(nativeElement);
        this.setParentWidth ? this.renderer.setStyle(parent, 'width', width + 'px')
            : this.renderer.setStyle(nativeElement, 'width', width + 'px');
    }
    setWidthUsingText(text) {
        this.setWidth(this.textWidth(text) + this.extraWidth + this.borderWidth + this.paddingWidth);
    }
    // Check placeholder width settings and set text width
    textForWidth(inputText, placeHolderText, setPlaceHolderWidth) {
        return (setPlaceHolderWidth && (inputText.length === 0 || !this.usePlaceHolderWhenEmpty)) ?
            placeHolderText : inputText;
    }
    textWidth(value) {
        const ctx = this.renderer.createElement('canvas').getContext('2d');
        const { fontStyle, fontVariant, fontWeight, fontSize, fontFamily } = this.style;
        // font string format: {normal, normal, 700, 20px, Roboto, "Helvetica Neue", sans-serif}
        ctx.font = fontStyle + ' ' + fontVariant + ' ' + fontWeight + ' ' + fontSize + ' ' + fontFamily;
        return ctx.measureText(value).width;
    }
    updateWidth() {
        const inputText = this.getInputValue();
        const placeHolderText = this._getProperty('placeholder');
        const inputTextWidth = this.textWidth(inputText) + this.extraWidth + this.borderWidth + this.paddingWidth;
        const setMinWidth = this.minWidth > 0 && this.minWidth > inputTextWidth;
        const setPlaceHolderWidth = this.includePlaceholder && placeHolderText.length > 0 &&
            (this.textWidth(placeHolderText) > this.textWidth(inputText));
        const setMaxWidth = this.maxWidth > 0 && (this.maxWidth < inputTextWidth);
        if (setMinWidth) {
            this.setWidth(this.minWidth);
        }
        else if (setMaxWidth) {
            this.setWidth(this.maxWidth);
        }
        else {
            this.setWidthUsingText(this.textForWidth(inputText, placeHolderText, setPlaceHolderWidth));
        }
    }
    _getProperty(property) {
        var _a;
        return (_a = this.element.nativeElement) === null || _a === void 0 ? void 0 : _a[property];
    }
    _sumPropertyValues(properties) {
        return properties.map(property => parseInt(this.style.getPropertyValue(property), 10))
            .reduce((a, b) => a + b, 0);
    }
}
AutoSizeInputDirective.ɵfac = function AutoSizeInputDirective_Factory(t) { return new (t || AutoSizeInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgModel, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 8), ɵngcc0.ɵɵdirectiveInject(AUTO_SIZE_INPUT_OPTIONS, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
AutoSizeInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AutoSizeInputDirective, selectors: [["", "autoSizeInput", ""]], hostBindings: function AutoSizeInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function AutoSizeInputDirective_input_HostBindingHandler($event) { return ctx.onInput($event.target); });
    } }, inputs: { extraWidth: "extraWidth", includeBorders: "includeBorders", includePadding: "includePadding", includePlaceholder: "includePlaceholder", maxWidth: "maxWidth", minWidth: "minWidth", setParentWidth: "setParentWidth", usePlaceHolderWhenEmpty: "usePlaceHolderWhenEmpty", useValueProperty: "useValueProperty" } });
AutoSizeInputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgModel, decorators: [{ type: Optional }] },
    { type: NgControl, decorators: [{ type: Optional }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AUTO_SIZE_INPUT_OPTIONS,] }] },
    { type: Renderer2 }
];
AutoSizeInputDirective.propDecorators = {
    extraWidth: [{ type: Input }],
    includeBorders: [{ type: Input }],
    includePadding: [{ type: Input }],
    includePlaceholder: [{ type: Input }],
    maxWidth: [{ type: Input }],
    minWidth: [{ type: Input }],
    setParentWidth: [{ type: Input }],
    usePlaceHolderWhenEmpty: [{ type: Input }],
    useValueProperty: [{ type: Input }],
    onInput: [{ type: HostListener, args: ['input', ['$event.target'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutoSizeInputDirective, [{
        type: Directive,
        args: [{
                selector: '[autoSizeInput]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.NgModel, decorators: [{
                type: Optional
            }] }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AUTO_SIZE_INPUT_OPTIONS]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { extraWidth: [{
            type: Input
        }], includeBorders: [{
            type: Input
        }], includePadding: [{
            type: Input
        }], includePlaceholder: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], minWidth: [{
            type: Input
        }], setParentWidth: [{
            type: Input
        }], usePlaceHolderWhenEmpty: [{
            type: Input
        }], useValueProperty: [{
            type: Input
        }], onInput: [{
            type: HostListener,
            args: ['input', ['$event.target']]
        }] }); })();

class AutoSizeInputModule {
}
AutoSizeInputModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AutoSizeInputModule });
AutoSizeInputModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AutoSizeInputModule_Factory(t) { return new (t || AutoSizeInputModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AutoSizeInputModule, { declarations: function () { return [AutoSizeInputDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AutoSizeInputDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutoSizeInputModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    AutoSizeInputDirective,
                ],
                exports: [
                    AutoSizeInputDirective,
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-autosize-input
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AUTO_SIZE_INPUT_OPTIONS, AutoSizeInputDirective, AutoSizeInputModule, DEFAULT_AUTO_SIZE_INPUT_OPTIONS };

//# sourceMappingURL=ngx-autosize-input.js.map